import { bUserService } from '@/utils/axios'

export const bUserServiceApi = {
  validBUser: '/api/TokenAuth/CheckUserName', // 用户信息
  getByProviderKey: '/api/services/app/AbpTenantService/GetByProviderKey', // 获取判断b平台是否激活
  registerBUser: '/api/TokenAuth/RegisterGetAnyUserAsync', // 注册
  getTenant: '/api/public/api/services/app/Tenant/getPaged', // 获取平台
  UserAudit: {
    GetPaged: '/api/services/app/UserAudit/GetPaged', // 获取入库审核记录(分页)
    CreateOrUpdate: '/api/services/app/UserAudit/CreateOrUpdate' // 获取入库审核记录(分页)
  }, // 入库审核
  ReloadAuthenticate: '/api/TokenAuth/ReloadAuthenticate' // 获取b平台token
}

export function validBUser(params) {
  return bUserService({
    url: bUserServiceApi.validBUser,
    method: 'get',
    params
  })
}

export function registerBUser(params) {
  return bUserService({
    url: bUserServiceApi.registerBUser,
    method: 'post',
    data: params
  })
}

export function getTenant(params) {
  return bUserService({
    url: bUserServiceApi.getTenant,
    method: 'get',
    params
  })
}

export function getByProviderKey(params) {
  return bUserService({
    url: bUserServiceApi.getByProviderKey,
    method: 'get',
    params: params
  })
}

// =================== 入库审核 ===================
// 获取入库审核记录(分页)
export function userAuditGetPaged(params, headers) {
  return bUserService({
    url: bUserServiceApi.UserAudit.GetPaged,
    method: 'get',
    params,
    headers
  })
}

// 创建入库审核记录
export function userAuditCreateOrUpdate(data) {
  return bUserService({
    url: bUserServiceApi.UserAudit.CreateOrUpdate,
    method: 'post',
    data
  })
}

// 创建入库审核记录
export function userAuditCreateOrUpdateA(data, headers) {
  return bUserService({
    url: bUserServiceApi.UserAudit.CreateOrUpdate,
    method: 'post',
    data,
    headers
  })
}
// =================== 入库审核 ===================

// 获取b平台token
export function platformCenterReloadAuthenticate(data, headers) {
  return bUserService({
    url: bUserServiceApi.ReloadAuthenticate,
    method: 'post',
    data,
    headers
  })
}
